export const canvasSize = '(max-width:820px)';
